import { sendData, getData } from './../../misc/server.js';
export default {
    state: {

        data: [],
        loading: false,
        current_time:null,
        notice_boards:null,
    },
    mutations:
    {

      
        SET_LOADING(state, payload) {
            state.loading = payload;
        },
        SET_CURRENT_TIME(state,payload)
        {
            state.current_time=payload;
        },
        SET_NOTICE_BOARD(state,payload)
        {
            state.notice_boards=payload;
        }


    },
    actions: {


        async get_home_data({ commit }, payload) {
            var url = "home_data/get";

            
            
            commit('SET_LOADING', true);
            var response = await getData(url);
            
            commit("SET_CLASS", response.classes,{root:true});
            commit("SET_EXAM", response.exams,{root:true});
            commit("SET_NOTICE_BOARD", response.notice_board,{root:true});
            commit("SET_CURRENT_TIME",response.current_time);
            commit('SET_LOADING', false);

        },



    },
    getters: {


    
        home_data_loading(state) {
            return state.loading;
        },
        current_time(state)
        {
            return state.current_time;
        },
        notice_boards(state)
        {
            return state.notice_boards;
        }
    

    }
}